export const MEDIA_URL = process.env.VUE_APP_MEDIA_URL;

export const GALLERY = [
  {
    img: '/images/proyectos/planta-solar-marti.jpg',
    captionTitle: 'Asesoría y permisología ambiental',
    captionContent: 'Proyecto Fotovoltaico Planta Solar Marti',
    alt: 'Asesoría y permisología ambiental, Proyecto Fotovoltaico Planta Solar Marti',
    type: 'image',
  },
  {
    img: '/images/proyectos/madrevieja.jpg',
    captionTitle: 'Estación Next Madre Vieja',
    captionContent:
      'Proyecto letreros Estación Next Madre Vieja, San Cristóbal, Republica Dominicana',
    alt: 'Proyecto Next Madre Vieja, San Cristóbal, República Dominicana',
    type: 'image',
  },
  {
    img: '/images/proyectos/banco-central.jpg',
    captionTitle: 'Banco Central de la República Dominicana',
    captionContent: 'Proyecto Letreros Institucionales, Santo Domingo.',
    alt: 'Letrero Banco Central de la República Dominicana',
    type: 'image',
  },
  {
    img: '/images/proyectos/hotel-intercontinental.jpg',
    captionTitle: 'Hotel Intercontinental',
    captionContent: 'Proyecto letreros Hotel Intercontinental, Santo Domingo.',
    alt: 'Letrero Hotel Intercontinental',
    type: 'image',
  },
  {
    img: '/images/proyectos/sirena-market.jpg',
    captionTitle: 'Sirena Market',
    captionContent:
      'Suministro e instalación de letreros Sirena Market, Avenida Sarasota. Santo Domingo',
    type: 'image',
    alt: 'Letreros Sirena Market, Avenida Sarasota. Santo Domingo',
  },
  {
    img: '/images/proyectos/shellah.jpg',
    captionTitle: 'Shell Arroyo Hondo',
    captionContent:
      'Proyecto letreros Estación Shell Arroyo Hondo, Santo Domingo Republica Dominicana.',
    alt: 'Proyecto Shell AH',
    type: 'image',
  },
  {
    img: '/images/proyectos/terminal-coastal.jpg',
    captionTitle: 'Terminal de Combustibles Coastal',
    captionContent:
      'Proyecto de iluminación LED. San Pedro de Macorís. República Dominicana',
    alt: 'Terminal de Combustibles Coastal',
    type: 'image',
  },
  {
    img: '/images/proyectos/total-las-palmas.jpg',
    captionTitle: 'Total Las Palmas',
    captionContent:
      'Proyecto letreros Estación Total Las Palmas, Santo Domingo. República Dominicana.',
    alt: 'Letrero Total Las Palmas',
    type: 'image',
  },
  {
    img: '/images/proyectos/imca-cat-oficina-principal.jpg',
    captionTitle: 'IMCA-CAT',
    captionContent:
      'Proyecto Letreros Oficina Principal Implementos y Maquinarias. Santo Domingo. República Dominicana.',
    alt: 'IMCA-CAT Proyecto Letreros Oficina Principal Implementos y Maquinarias. Santo Domingo. República Dominicana.',
    type: 'image',
  },
  {
    img: '/images/proyectos/totalenergies-las-palmeras.jpg',
    captionTitle: 'TotalEnergies Las Palmeras',
    captionContent:
      'Proyecto letrero principal Estación TotalEnergies Las Palmeras, Monte Plata, Republica Dominicana.',
    alt: 'TotalEnergies Las Palmeras, Monte Plata, República Dominicana',
    type: 'image',
  },
  {
    name: 'texaco',
    thumbnail: '/images/proyectos/texaco-villa-bavaro.jpg',
    source: `${MEDIA_URL}cliente-torbel__texaco-low.mp4`,
    captionTitle: 'Torbel Cliente Texaco',
    captionContent: '',
    type: 'video',
  },
  {
    img: '/images/proyectos/edificiocorp.jpg',
    captionTitle: 'Edificio Corporativo',
    captionContent:
      'Proyecto iluminación LED Fachada Edificio Corporativo Santo Domingo, Republica Dominicana.',
    alt: 'Fachada Edificio Corporativo',
    type: 'image',
  },
  {
    img: '/images/proyectos/propagassfo.jpg',
    captionTitle: 'Propagas San Francisco',
    captionContent:
      'Proyecto letreros Envasadora Propagas San Francisco. San Francisco, Republica Dominicana.',
    alt: 'Proyecto Propagas',
    type: 'image',
  },
  {
    img: '/images/proyectos/nextnuevosol.jpg',
    captionTitle: 'Next Nuevo Sol',
    captionContent:
      'Proyecto letreros Estación Next Nuevo Sol, Santo Domingo República Dominicana.',
    alt: 'Proyecto Next NS',
    type: 'image',
  },
  {
    name: 'esso',
    thumbnail: '/images/proyectos/esso.jpg',
    source: `${MEDIA_URL}cliente-torbel__esso-low.mp4`,
    captionTitle: 'Torbel Cliente Texaco',
    captionContent: '',
    type: 'video',
  },
  {
    img: '/images/proyectos/tropigas-marte.jpg',
    captionTitle: 'Tropigas Marte',
    captionContent:
      'Proyecto letreros Estación Tropigas Marte. República Dominicana.',
    alt: 'Letrero Tropigas Marte',
    type: 'image',
  },
  {
    name: 'sunix',
    thumbnail: '/images/proyectos/sunix-aeropuerto-romana.jpg',
    source: `${MEDIA_URL}cliente-torbel__sunix-low.mp4`,
    captionTitle: 'Torbel Cliente Texaco',
    captionContent: '',
    type: 'video',
  },
  {
    img: 'images/proyectos/mcdonals-lincoln.jpg',
    captionTitle: 'Mc Donald’s Lincoln',
    captionContent:
      'Proyectos letreros Restaurante Mc Donald’s Lincoln, Santo Domingo.',
    alt: 'Letrero Mc Donald’s Lincoln',
    type: 'image',
  },
  {
    img: '/images/proyectos/texaco-villa-bavaro.jpg',
    captionTitle: 'Texaco Villa Bavaro',
    captionContent:
      'Proyecto letreros Estación Texaco Villa Bávaro, Bávaro. República Dominicana',
    alt: 'Letrero Texaco Villa Bavaro',
    type: 'image',
  },
  {
    img: '/images/proyectos/payless.jpg',
    captionTitle: 'Payless',
    captionContent: 'Proyecto Letreros Tienda Payless. República Dominicana.',
    alt: 'Letrero Payless',
    type: 'image',
  },
  {
    img: '/images/proyectos/eco-petroleo.jpg',
    captionTitle: 'Eco Petroleo',
    captionContent:
      'Proyecto letreros Estación Eco Petroleo. República Dominicana.',
    alt: 'Letrero Eco Petroleo',
    type: 'image',
  },
  {
    img: '/images/proyectos/esso-venezuela.jpg',
    captionTitle: 'Tienda de conveniencia SOL',
    captionContent:
      'Proyecto de iluminación LED. Estación ESSO Venezuela. República Dominicana',
    alt: 'Tienda de conveniencia SOL, Estación ESSO Venezuela',
    type: 'image',
  },
  {
    img: '/images/proyectos/promerica.jpg',
    captionTitle: 'Banco Promerica',
    captionContent: 'Proyecto letreros promerica. República Dominicana.',
    alt: 'Letrero Banco Promerica',
    type: 'image',
  },
  {
    img: '/images/proyectos/multiplaza.jpg',
    captionTitle: 'Multiplaza',
    captionContent:
      'Proyecto Letreros Multiplaza. La Romana. República Dominicana.',
    alt: 'Letrero Multiplaza',
    type: 'image',
  },
  {
    img: '/images/proyectos/mcdonals-agora.jpg',
    captionTitle: 'Mcdonals Agora Mall',
    captionContent:
      'Proyecto letreros Mcdonals Agora Mall. República Dominicana',
    alt: 'Letrero Mcdonals Agora Mall',
    type: 'image',
  },
  {
    img: '/images/proyectos/estacion-next.jpg',
    captionTitle: 'Next',
    captionContent: 'Proyecto letreros Next. República Dominicana',
    alt: 'Letrero Next',
    type: 'image',
  },
  {
    img: '/images/proyectos/honda.jpg',
    captionTitle: 'Honda',
    captionContent: 'Proyecto letreros Honda. República Dominicana',
    alt: 'Letrero Honda',
    type: 'image',
  },
  {
    img: '/images/proyectos/sunix-hipaniola-santiago.jpg',
    captionTitle: 'Sunix Hispaniola Santiago',
    captionContent:
      'Proyecto letreros Estación Sunix Hispaniola. Santiago. República Dominicana',
    alt: 'Letreros Estación Sunix Hispaniola',
    type: 'image',
  },
  {
    img: '/images/proyectos/esso.jpg',
    captionTitle: 'ESSO Geremias La Vega',
    captionContent:
      'Proyecto letreros Estación ESSO Geremias. La Vega. República Dominicana',
    alt: 'Letreros Estación ESSO Geremias La Vega',
    type: 'image',
  },
  {
    img: '/images/proyectos/gym.jpg',
    captionTitle: 'The Training Club',
    captionContent: 'The Training Club',
    alt: 'The Training Club',
    type: 'image',
  },
  {
    img: '/images/proyectos/tropigas-la-caleta.jpg',
    captionTitle: 'Tropigas La Caleta',
    captionContent:
      'Proyecto letreros Estación Tropigas La Caleta. República Dominicana',
    alt: 'Letreros Estación Tropigas La Caleta',
    type: 'image',
  },
  {
    img: '/images/proyectos/dinasa.jpg',
    captionTitle: 'Dinasa',
    captionContent: 'Proyecto letreros Dinasa. Haití',
    alt: 'Letrero Dinasa',
    type: 'image',
  },
  {
    img: '/images/proyectos/imca-cat.jpg',
    captionTitle: 'IMCA-CAT',
    captionContent:
      'Proyecto Letreros Oficina Principal Implementos y Maquinarias. Santo Domingo. República Dominicana.',
    alt: 'Letrero IMCA-CAT',
    type: 'image',
  },
  {
    img: '/images/proyectos/propagas-bocachica.jpg',
    captionTitle: 'Propagas Boca Chica',
    captionContent:
      'Proyecto letreros Estación Propagas Boca Chica. República Dominicana',
    alt: 'Letreros Estación Propagas Boca Chica',
    type: 'image',
  },
];

export const GALLERY_VIDEOS = [
  {
    name: 'texaco',
    thumbnail: '/images/proyectos/texaco-villa-bavaro.jpg',
    source: `${MEDIA_URL}cliente-torbel__texaco-low.mp4`,
    captionTitle: 'Torbel Cliente Texaco',
    captionContent: '',
  },
  {
    name: 'esso',
    thumbnail: '/images/proyectos/esso.jpg',
    source: `${MEDIA_URL}cliente-torbel__esso-low.mp4`,
    captionTitle: 'Torbel Cliente Texaco',
    captionContent: '',
  },
  {
    name: 'sunix',
    thumbnail: '/images/proyectos/sunix-aeropuerto-romana.jpg',
    source: `${MEDIA_URL}cliente-torbel__sunix-low.mp4`,
    captionTitle: 'Torbel Cliente Texaco',
    captionContent: '',
  },
];

export const GALLERY_IMAGES = [
  {
    img: '/images/proyectos/shellah.jpg',
    captionTitle: 'Shell Arroyo Hondo',
    captionContent:
      'Proyecto letreros Estación Shell Arroyo Hondo, Santo Domingo Republica Dominicana.',
    alt: 'Proyecto Shell AH',
  },
  {
    img: '/images/proyectos/propagassfo.jpg',
    captionTitle: 'Propagas San Francisco',
    captionContent:
      'Proyecto letreros Envasadora Propagas San Francisco. San Francisco, Republica Dominicana.',
    alt: 'Proyecto Propagas',
  },
  {
    img: '/images/proyectos/edificiocorp.jpg',
    captionTitle: 'Edificio Corporativo',
    captionContent:
      'Proyecto iluminación LED Fachada Edificio Corporativo Santo Domingo, Republica Dominicana.',
    alt: 'Fachada Edificio Corporativo',
  },
  {
    img: '/images/proyectos/madrevieja.jpg',
    captionTitle: 'Estación Next Madre Vieja',
    captionContent:
      'Proyecto letreros Estación Next Madre Vieja, San Cristóbal, Republica Dominicana',
    alt: 'Proyecto Next Madre Vieja, San Cristóbal, República Dominicana',
  },
  {
    img: '/images/proyectos/totalenergies-las-palmeras.jpg',
    captionTitle: 'TotalEnergies Las Palmeras',
    captionContent:
      'Proyecto letrero principal Estación TotalEnergies Las Palmeras, Monte Plata, Republica Dominicana.',
    alt: 'TotalEnergies Las Palmeras, Monte Plata, República Dominicana',
  },
  {
    img: '/images/proyectos/banco-central.jpg',
    captionTitle: 'Banco Central de la República Dominicana',
    captionContent: 'Proyecto Letreros Institucionales, Santo Domingo.',
    alt: 'Letrero Banco Central de la República Dominicana',
  },

  {
    img: '/images/proyectos/sirena-market.jpg',
    captionTitle: 'Sirena Market',
    captionContent:
      'Suministro e instalación de letreros Sirena Market, Avenida Sarasota. Santo Domingo',
    alt: 'Letreros Sirena Market, Avenida Sarasota. Santo Domingo',
  },
  {
    img: '/images/proyectos/hotel-intercontinental.jpg',
    captionTitle: 'Hotel Intercontinental',
    captionContent: 'Proyecto letreros Hotel Intercontinental, Santo Domingo.',
    alt: 'Letrero Hotel Intercontinental',
  },
  {
    img: '/images/proyectos/tropigas-marte.jpg',
    captionTitle: 'Tropigas Marte',
    captionContent:
      'Proyecto letreros Estación Tropigas Marte. República Dominicana.',
    alt: 'Letrero Tropigas Marte',
  },
  {
    img: '/images/proyectos/terminal-coastal.jpg',
    captionTitle: 'Terminal de Combustibles Coastal',
    captionContent:
      'Proyecto de iluminación LED. San Pedro de Macorís. República Dominicana',
    alt: 'Terminal de Combustibles Coastal',
  },
  {
    img: 'images/proyectos/mcdonals-lincoln.jpg',
    captionTitle: 'Mc Donald’s Lincoln',
    captionContent:
      'Proyectos letreros Restaurante Mc Donald’s Lincoln, Santo Domingo.',
    alt: 'Letrero Mc Donald’s Lincoln',
  },
  {
    img: '/images/proyectos/total-las-palmas.jpg',
    captionTitle: 'Total Las Palmas',
    captionContent:
      'Proyecto letreros Estación Total Las Palmas, Santo Domingo. República Dominicana.',
    alt: 'Letrero Total Las Palmas',
  },
  {
    img: '/images/proyectos/imca-cat-bavaro.jpg',
    captionTitle: 'IMCA-CAT',
    captionContent:
      'IMCA-CAT Proyecto letreros exteriores, Implementos y Maquinarias Bavaro, República Dominicana.',
    alt: 'IMCA-CAT Proyecto letreros exteriores, Implementos y Maquinarias Bavaro, República Dominicana.',
  },
  {
    img: '/images/proyectos/texaco-villa-bavaro.jpg',
    captionTitle: 'Texaco Villa Bavaro',
    captionContent:
      'Proyecto letreros Estación Texaco Villa Bávaro, Bávaro. República Dominicana',
    alt: 'Letrero Texaco Villa Bavaro',
  },
  {
    img: '/images/proyectos/payless.jpg',
    captionTitle: 'Payless',
    captionContent: 'Proyecto Letreros Tienda Payless. República Dominicana.',
    alt: 'Letrero Payless',
  },
  {
    img: '/images/proyectos/eco-petroleo.jpg',
    captionTitle: 'Eco Petroleo',
    captionContent:
      'Proyecto letreros Estación Eco Petroleo. República Dominicana.',
    alt: 'Letrero Eco Petroleo',
  },
  {
    img: '/images/proyectos/esso-venezuela.jpg',
    captionTitle: 'Tienda de conveniencia SOL',
    captionContent:
      'Proyecto de iluminación LED. Estación ESSO Venezuela. República Dominicana',
    alt: 'Tienda de conveniencia SOL, Estación ESSO Venezuela',
  },
  {
    img: '/images/proyectos/promerica.jpg',
    captionTitle: 'Banco Promerica',
    captionContent: 'Proyecto letreros promerica. República Dominicana.',
    alt: 'Letrero Banco Promerica',
  },
  {
    img: '/images/proyectos/multiplaza.jpg',
    captionTitle: 'Multiplaza',
    captionContent:
      'Proyecto Letreros Multiplaza. La Romana. República Dominicana.',
    alt: 'Letrero Multiplaza',
  },
  {
    img: '/images/proyectos/mcdonals-agora.jpg',
    captionTitle: 'Mcdonals Agora Mall',
    captionContent:
      'Proyecto letreros Mcdonals Agora Mall. República Dominicana',
    alt: 'Letrero Mcdonals Agora Mall',
  },
  {
    img: '/images/proyectos/estacion-next.jpg',
    captionTitle: 'Next',
    captionContent: 'Proyecto letreros Next. República Dominicana',
    alt: 'Letrero Next',
  },
  {
    img: '/images/proyectos/honda.jpg',
    captionTitle: 'Honda',
    captionContent: 'Proyecto letreros Honda. República Dominicana',
    alt: 'Letrero Honda',
  },
  {
    img: '/images/proyectos/sunix-hipaniola-santiago.jpg',
    captionTitle: 'Sunix Hispaniola Santiago',
    captionContent:
      'Proyecto letreros Estación Sunix Hispaniola. Santiago. República Dominicana',
    alt: 'Letreros Estación Sunix Hispaniola',
  },
  {
    img: '/images/proyectos/esso.jpg',
    captionTitle: 'ESSO Geremias La Vega',
    captionContent:
      'Proyecto letreros Estación ESSO Geremias. La Vega. República Dominicana',
    alt: 'Letreros Estación ESSO Geremias La Vega',
  },
  {
    img: '/images/proyectos/gym.jpg',
    captionTitle: 'The Training Club',
    captionContent: 'The Training Club',
    alt: 'The Training Club',
  },
  {
    img: '/images/proyectos/tropigas-la-caleta.jpg',
    captionTitle: 'Tropigas La Caleta',
    captionContent:
      'Proyecto letreros Estación Tropigas La Caleta. República Dominicana',
    alt: 'Letreros Estación Tropigas La Caleta',
  },
  {
    img: '/images/proyectos/dinasa.jpg',
    captionTitle: 'Dinasa',
    captionContent: 'Proyecto letreros Dinasa. Haití',
    alt: 'Letrero Dinasa',
  },
  {
    img: '/images/proyectos/imca-cat.jpg',
    captionTitle: 'IMCA-CAT',
    captionContent:
      'Proyecto Letreros Oficina Principal Implementos y Maquinarias. Santo Domingo. República Dominicana.',
    alt: 'Letrero IMCA-CAT',
  },
  {
    img: '/images/proyectos/propagas-bocachica.jpg',
    captionTitle: 'Propagas Boca Chica',
    captionContent:
      'Proyecto letreros Estación Propagas Boca Chica. República Dominicana',
    alt: 'Letreros Estación Propagas Boca Chica',
  },
];
